import { render } from "./Label.vue?vue&type=template&id=fa6bfeb6&scoped=true"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import "./Label.vue?vue&type=style&index=0&id=fa6bfeb6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fa6bfeb6"

export default script